import React, { useEffect, useState } from 'react';
import PlayerCard from './PlayerCard';
import { Player } from '../constants/types';


interface SquadGridProps {
  squad: Player[];
}

const PlayerGrid = ({squad}: SquadGridProps) => {

  const [gridColumns, setGridColumns] = useState('repeat(4, 1fr)');

  useEffect(() => {
      const handleResize = () => {
          if (window.innerWidth <= 600) {
              setGridColumns('repeat(1, 1fr)');
          } else if (window.innerWidth <= 800) {
              setGridColumns('repeat(2, 1fr)');
          } else if (window.innerWidth <= 1200) {
              setGridColumns('repeat(3, 1fr)');
          } else {
              setGridColumns('repeat(5, 1fr)');
          }
      };

      // Initial check
      handleResize();

      window.addEventListener('resize', handleResize);

      return () => {
          window.removeEventListener('resize', handleResize);
      };
  }, []);

  const sortedSquad = squad.sort((a, b) => a.jersey_number - b.jersey_number)

  const squadGridStyle = {
      display: 'grid',
      gridTemplateColumns: gridColumns,
      gap: '20px',
  };

  
  return (
    <div style={squadGridStyle}>
      {sortedSquad.map((player, index) => (
        <PlayerCard
          key={index}
          player={{
          player_name:player.player_name,
          jersey_number:player.jersey_number,
          position:player.position,
          age:player.age,
          player_picture:player.player_picture,
          place_of_birth:player.place_of_birth,
          team:player?.team,
          twitter:player?.twitter,
          instagram:player?.instagram,
          wikipedia:player?.wikipedia,
          website:player?.website
          }}
        />
      ))}
    </div>
  );
};

export default PlayerGrid;
